import * as Mui from "@mui/material";
import { Route, Routes } from "react-router";
import { TransactionHistoryTable } from "../component/transaction-history/TransactionHistoryTable";

export const TransactionHistoryPage = () => {
  return (
    <Mui.Box>
      <Routes>
        <Route index={true} element={<TransactionHistoryTable />} />
         </Routes>
      
    </Mui.Box>
  )
}
